'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      className={cn(
        `
        bg-white peer border-input dark:bg-input/30
        data-[state=checked]:bg-transparent
        data-[state=checked]:text-black
        focus-visible:border-ring focus-visible:ring-ring/50
        aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40
        aria-invalid:border-destructive
        size-4 shrink-0 rounded-[4px] border shadow-xs
        transition-shadow outline-none focus-visible:ring-[3px]
        disabled:cursor-not-allowed disabled:opacity-50
      `,
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        className='flex flex-row items-center justify-center text-current transition-none'
      >
        <CheckIcon className='size-3' />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
